import { TradingIntent } from "features/onboarding/guided/intent";
import { SignalsBotsArt } from "features/onboarding/art/SignalsBotsArt";
import { GridBotsArt } from "features/onboarding/art/GridBotsArt";
import { DcaBotsArt } from "features/onboarding/art/DcaBotsArt";
import { TradingViewBotsArt } from "features/onboarding/art/TradingViewBotsArt";
import { HedgingThumb } from "features/onboarding/art/MethodThumbs";

const METHOD_ART = {
  signals: SignalsBotsArt,
  grid: GridBotsArt,
  tradingview: TradingViewBotsArt,
  dca: DcaBotsArt,
  hedging: HedgingThumb,
};

/** The full illustration for a trading method (hedging uses its compact one). */
const MethodArt = ({
  method,
  play = true,
}: {
  method: TradingIntent;
  play?: boolean;
}) => {
  const Illustration = METHOD_ART[method];
  return <Illustration play={play} />;
};

export default MethodArt;
